/**
 * Key Represent Uniquely identify field
 * label are Header of table
 * referencedField is backend response key by which value will be show to it.
 * representation means what will be show in table UI
 *
 */

const testListColumns = [
  { key: 'id', label: '#', width: '9%' },
  {
    key: 'totalScore',
    label: 'Total Score',
    referredField: 'score',
    representation: (value) => `${value}%`,
    className: 'score-qnt',
  },
  {
    key: 'date',
    label: 'Test Attempted Date',
    referredField: 'createdAt',
    representation: (value, additionalParameterForOperation) =>
      additionalParameterForOperation.moment(value).format('lll'),
  },
  {
    key: 'time',
    label: 'Test Completed In',
    referredField: 'user_time_value',
    operation: {
      field: 'isNegative',
      true: (item, additionalParameterForOperation) =>
        additionalParameterForOperation.timer - item.user_time_value,
      false: (item, additionalParameterForOperation) =>
        parseInt(additionalParameterForOperation.timer) + item.user_time_value,
    },
    representation: (value, additionalParameterForOperation) =>
      additionalParameterForOperation.SecondsToHHMMSS(value),
  },
  {
    key: 'status',
    label: 'Status',
    condition: {
      pending: {
        label: 'Incomplete',
        className: 'mock-status not-attempted',
      },
      completed: {
        label: 'Completed',
        className: 'mock-status',
      },
    },
  },
];
const cbtColor = {
  attempted: {
    color: '#d0d03d',
    className: 'border-yellow',
  },
  notAttempted: {
    color: '#444d58',
    className: 'not-ans',
  },
  incorrect: {
    color: '#db4040',
    className: 'border-red',
  },
  correct: {
    color: '#39c089',
    className: 'border-green',
  },
};
// const cbtTestPageSliderColor = {
//   attemptedQuestion,
//   notAttemptedQuestion,
// };

// const cbtFinishPageSliderColor = {
//   attemptedQuestion,
//   notAttemptedQuestion,
//   wrongAnswerQuestion,
//   rightAnswerQuestion,
// };

module.exports = {
  testListColumns,
  cbtColor,
};



// WEBPACK FOOTER //
// ./src/views/ESG/common.js